<script >

import ContactStrip from "@/components/parts/ContactStrip.vue";

export default {
  components: {ContactStrip}
}
</script>

<template>
  <transition name="slide-fade" >
    <div style="min-height: 70vh">
      <div class="uk-padding ">
        <h1 class="uk-heading-line uk-text-center"><span> Compliance Monitoring </span></h1>
        <div class="uk-container uk-container-small" id="output-delivery-compliance">

          <h3 class="uk-heading-bullet  h2Style">Output Delivery Compliance</h3>
          <p>
            The Government appropriates millions every year to Statutory
            Authorities and Non-Government Organizations (NGOs) for the delivery of services (Outputs). FINCOR
            can help to monitor the delivery of those services and provide independent reporting to the
            Government on the use of Output funding and the delivery of services.
          </p>
          <p>
            We can also provide independent financial management services to ensure funds are disbursed
            according to any conditions attached to such funding and are not utilized for unintended purposes.
          </p>
        </div>
      </div>
      <div class="uk-padding uk-background-muted" id="FeeRemittance">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Fee Remittance Compliance</h3>
          <p>
            The Government collects fees from certain private entities which are
            largely based on the honour system (Tourism Accommodation Tax as an example), FINCOR can do
            independent compliance checks to ensure entities are properly calculating and remitting their fees to
            the Government in a timely manner.
          </p>
        </div>
      </div>
      <div class="uk-padding " id="ComplianceInspections">
        <div class="uk-container uk-container-small">

          <h3 class="uk-heading-bullet  h2Style">Compliance Inspections</h3>
          <p>
            Do you have an inspection regime but struggle with the resources to monitor
            your clients or the sector for which you are responsible? FINCOR can help by augmenting your in-house
            team to carry out onsite inspections, prepare inspection reports, and follow up on compliance
            violations. Our team has a firm grasp of the legal and financial requirements for various sectors (such as
            Designated Non-Financial Businesses and Professions (DNFBP) and can help you fulfill your compliance
            obligations with independent assurance.
          </p>
          <p>
            Has your client given an undertaking to reduce costs to ensure they can meet loan obligations? FINCOR
            can independently review and verify to ensure they are meeting their undertaking to the bank.
          </p>
        </div>
      </div>
      <ContactStrip />
    </div>
  </transition>

</template>

<style scoped>
.h2Style{
  font-family: 'Overlock SC';

}
</style>